import axios from 'axios';

import { action, observable } from 'mobx';
import { Config } from '../config';

class Page {
  @observable data = {};

  @action
  populate = async (props) => {
    let slug = props.match.params.slug || 'more-than-height';
    if (slug === "ar") slug = "more-than-height";
    const pageEndpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.wp}${Config.endpoint.wordpress.pages}?slug=${slug}`
    const response = await axios(pageEndpoint)
    this.data = (response && response.data.length > 0) ? response.data[0].acf.page_content_blocks : this.data;
  }
}

const PageStore = new Page();
export default PageStore;
